import { Box } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React, { useCallback } from "react";
import { getMonthOptions, YEARS } from "../../variables/constants";
import { LoadingButton } from "@mui/lab";
import useFileDownloader from "../../hooks/useFileDownloader";
import { apiEndPoints } from "../../variables/apiEndpoints";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";

type LoanSummaryFilterProps = {
  selectedMonth: number;
  setSelectedMonth: Function;
  selectedYear: number;
  setSelectedYear: Function;
};

const TableFilters = (props: LoanSummaryFilterProps) => {
  const { selectedMonth, setSelectedMonth, selectedYear, setSelectedYear } =
    props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [onSuccess, setOnSuccess] = React.useState(false);
  const [snackbarMsg, setSnackbarMsg] = React.useState("");
  const { downloadFile } = useFileDownloader();

  const handleDownload = useCallback(async () => {
    setIsLoading(true);
    const body = {
      month: selectedMonth,
      year: selectedYear,
    };
    const result = await downloadFile({
      url: `/${apiEndPoints.investmentSummary}`,
      method: "post",
      fileName: "InvestmentStatementSummary.pdf",
      data: body,
    });
    setIsLoading(false);
    if (!result.success) {
      setSnackbarMsg(result.errorMessage || "Error downloading file");
      setOnSuccess(true);
    }
  }, [downloadFile]);

  return (
    <Box className="toolbar-filter">
      <Box className="dropdowns">
        <FormControl className="dropdown" size="small">
          <InputLabel id="demo-simple-select-label">Month</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedMonth}
            label="Month"
            onChange={(e) => setSelectedMonth(e.target.value as number)}
          >
            {getMonthOptions().map((month) => (
              <MenuItem
                key={month.value}
                value={month.value}
                selected={month.default}
              >
                {month.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className="dropdown" size="small">
          <InputLabel id="demo-simple-select-label">Year</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Year"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value as number)}
          >
            {YEARS.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box>
        <LoadingButton
          variant="outlined"
          data-testid="exportPdfBtn"
          size="small"
          className="export-button"
          onClick={handleDownload}
          loading={isLoading}
          sx={{ marginRight: "26px", width: "117px", height: "36px" }}
        >
          {"EXPORT PDF"}
        </LoadingButton>
      </Box>
      <CustomSnackbar
        open={onSuccess}
        message={snackbarMsg}
        setOpen={setOnSuccess}
      />
    </Box>
  );
};

export default TableFilters;
